import { FormType } from './form-type.enum';
import { InventorySystem } from 'src/app/shared/models/inventory-system.enum';
import {BookingAccount} from "./booking-account";

export class FormInitModalData {
  formType = FormType.Synchronized;
  inventorySystem = InventorySystem.Bokun;
  bookingNo: string;
}
